import React from "react";
import { useCarousel } from "../hooks/useCarousel";
import Bell from "../assets/icons/bell.svg";
import CaretLeft from "../assets/icons/caret-left.svg";
import CaretRight from "../assets/icons/caret-right.svg";
import { useGlobalState } from "../context/Global";
import { useWindowSize } from "react-use";

function Alerts() {
  const { data } = useGlobalState();
  const { width } = useWindowSize();
  const [active, style, next, prev] = useCarousel(Array.isArray(data.alerts?.alert) ? data.alerts?.alert : null);

  return (
    <div className="bg-primary-light text-primary-dark mb-6 overflow-hidden">
      <div className="xl:container">
        {data.alerts && data.alerts.alert && (
          <div className="flex justify-between font-bold items-center overflow-hidden">
            <div className="w-10 h-16 bg-primary-light relative z-10"></div>
            <div className="w-10 h-16 bg-primary-light relative z-10 mr-4 flex items-center">
              <Bell width="24" height="24" className="text-primary-dark fill-current " />
            </div>
            <div className="h-16 relative w-full flex items-center ">
              <div className="flex carousel-content items-center absolute transition-all duration-300 leading-tight" style={{ ...style }}>
                {Array.isArray(data.alerts?.alert) ? (
                  data.alerts?.alert?.map((alert, index) => (
                    <div
                      className="carousel-item h-full"
                      style={{
                        width: width > 1280 ? "1000px" : "100vw",
                        paddingRight: "250px",
                      }}
                      key={index}
                    >
                      {alert}
                    </div>
                  ))
                ) : (
                  <div
                    className="carousel-item h-full"
                    style={{
                      width: width > 1280 ? "1000px" : "100vw",
                      paddingRight: "250px",
                    }}
                  >
                    {data.alerts?.alert}
                  </div>
                )}
              </div>
            </div>
            <div className="w-8 h-16 bg-primary-light relative z-10"></div>
            <div className="flex items-center bg-primary-light relative z-10 h-16 pl-4">
              {Array.isArray(data.alerts?.alert) && (
                <>
                  <div onClick={() => prev()} className="z-10 relative bg-white rounded-full w-8 h-8 flex justify-center cursor-pointer">
                    <CaretLeft className=" fill-current" width="8" />
                  </div>
                  <div className="mx-2">
                    {active + 1}/{data.alerts?.alert?.length}
                  </div>
                  <div onClick={() => next()} className="z-10 relative bg-white rounded-full w-8 h-8 flex justify-center items-center cursor-pointer">
                    <CaretRight className=" fill-current" width="8" />
                  </div>
                </>
              )}
            </div>
            <div className="w-10 h-16 bg-primary-light relative z-10"></div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Alerts;
